import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDisplay,
    BannerLinks,
    BannerOfferColumn,
    BannerOfferColumns,
    BannerSubtitle,
    BannerText,
    BannerTextContainer,
    BoundedContent,
    Button,
    Link,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { markdownBoldTextParser } from '../../../../utils/markdownBoldTextParser';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const StatsSection = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const ctaRef = useTrackNavigationClicked(
        'Design Services',
        'Feature Banner Stats Section CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    const statistics = [
        {
            id: 'statistic-1',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 1.value'),
        },
        {
            id: 'statistic-2',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 2.value'),
        },
        {
            id: 'statistic-3',
            text: t('Logomaker GenAi Landing Page > Stats > Stat 3.value'),
        },
    ];

    const parsedStatistics = statistics.map((stat) => {
        const textParts = markdownBoldTextParser(stat.text);
        return {
            display: textParts.find((part) => part.isBold)?.text || '',
            subtitle: textParts.find((part) => !part.isBold)?.text?.trim() || '',
        };
    });

    return (
        <BoundedContent
            backgroundColor="warm-white"
            paddingBottom={{ xs: 4, sm: 5, md: 5, lg: 5 }}
            as="section"
            id="stats"
        >
            <Banner
                variant="full-width-image"
                textBoxHorizontalAlign="center"
                backgroundColor="warm-white"
                multiColumnOffer
                style={{ minHeight: 'auto' }}
            >
                <BannerTextContainer style={{ width: '100%', maxWidth: '1000px' }}>
                    <BannerText>
                        <BannerOfferColumns>
                            {parsedStatistics.map(({ display, subtitle }, index) => (
                                <BannerOfferColumn key={index}>
                                    <BannerDisplay>{display}</BannerDisplay>
                                    <BannerSubtitle>{subtitle}</BannerSubtitle>
                                </BannerOfferColumn>
                            ))}
                        </BannerOfferColumns>
                        <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                            <Button
                                skin="primary"
                                textAlign="center"
                                render={(props) => (
                                    // TODO: Add tracking
                                    <Link
                                        to={logomakerCtaPathByLocale(locale)}
                                        className={props.className}
                                        ref={ctaRef}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {t('Logomaker GenAi Landing Page > Stats > CTA Text.value')}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
            </Banner>
        </BoundedContent>
    );
};

export default StatsSection;
